import { useState } from "react";
import styles from "./DigitalWomenHealthLifeStage.module.css";
// ─── SVG Icons ────────────────────────────────────────────────
const SearchIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>);
const BellIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>);
const HelpIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>);
const EditIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>);
const PlusIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
const PhoneIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.41 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>);
const MailIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>);
const MapPinIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>);
const CheckIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>);
const VerifiedIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="#22c55e"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>);
const ActivityIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>);
const CalendarIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>);
const ArrowRightIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>);
const AlertTriangleIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>);
const BookIcon = () => (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#a855f7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>);
const HeartIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ec4899" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>);
const BarChartIcon = () => (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>);
const ShieldIcon = () => (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>);
const ClipboardIcon = () => (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>);
const SparkleIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/></svg>);
const TargetIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>);
const CheckCircleIcon = ({ color = "#22c55e" }) => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>);

// Stage-specific small icons
const ReproductiveIcon = ({ size = 18 }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>);
const PregnancyStageIcon = ({ size = 18 }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><circle cx="12" cy="16" r="1"/></svg>);

// Journey stage icons
const AdolescenceIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="7" r="4"/><path d="M12 11v4"/><path d="M9 21l3-6 3 6"/></svg>);
const YoungAdultIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M6 20v-2a6 6 0 0 1 12 0v2"/></svg>);
const PostpartumIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/></svg>);
const PerimenopauseIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><path d="M12 2v3"/><path d="M12 19v3"/><path d="M4.22 4.22l2.12 2.12"/><path d="M17.66 17.66l2.12 2.12"/><path d="M2 12h3"/><path d="M19 12h3"/></svg>);
const MenopauseIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a10 10 0 1 0 10 10"/><path d="m9 9 3 3 3-3"/></svg>);
const SeniorIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M20 8v6"/><path d="M23 11h-6"/></svg>);

// Data card icons
const MenstrualIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ec4899" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>);
const IntentIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>);
const ContraceptionIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="m9 9 6 6"/><path d="m15 9-6 6"/></svg>);
const ObstetricIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>);
const ConcernIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>);
const PreventiveIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>);

// AI Insight icons
const CycleIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#a855f7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>);
const FertilityIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ec4899" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>);
const NutritionIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a10 10 0 1 0 10 10"/><path d="M12 6v6l4 2"/></svg>);
const AppointmentIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>);

// ─── Data ─────────────────────────────────────────────────────
const lifeStages = [
  { name: "Adolescence",       icon: <AdolescenceIcon />,   state: "past" },
  { name: "Young Adult",       icon: <YoungAdultIcon />,    state: "past" },
  { name: "Reproductive Age",  icon: <ReproductiveIcon />,  state: "active" },
  { name: "Pregnancy",         icon: <PregnancyStageIcon />,state: "future" },
  { name: "Postpartum",        icon: <PostpartumIcon />,    state: "future" },
  { name: "Perimenopause",     icon: <PerimenopauseIcon />, state: "future" },
  { name: "Menopause",         icon: <MenopauseIcon />,     state: "future" },
  { name: "Senior Women's Health", icon: <SeniorIcon />,   state: "future" },
];

const TABS = ["Overview","Menstrual Health","Reproductive Health","Fertility","Assessments","Preventive Care","Lifestyle","Notes"];

const stageSummaryCards = [
  {
    label: "Current Life Stage",
    value: "Reproductive Age",
    sub: "Preconception / Fertility Readiness",
    subColor: "#ec4899",
    icon: <ReproductiveIcon size={16} />,
    bg: "#faf5ff", border: "#e9d5ff",
  },
  {
    label: "Confidence Score",
    value: "High",
    isProgress: true,
    icon: <TargetIcon />,
    bg: "#f0fdf4", border: "#bbf7d0",
  },
  {
    label: "Transition Signals",
    lines: ["Ovulatory cycles", "Stable ± 2–4 days", "Actively planning pregnancy"],
    icon: <ActivityIcon />,
    bg: "#fff7ed", border: "#fed7aa",
  },
  {
    label: "Stage Since",
    value: "Jan 2023",
    sub: "1 year 4 months",
    badge: "Ongoing",
    icon: <CalendarIcon />,
    bg: "#eff6ff", border: "#bfdbfe",
  },
  {
    label: "Next Likely Stage",
    value: "Pregnancy",
    sub: "Likelihood: Moderate",
    subColor: "#f59e0b",
    sub2: "In next 6–12 months",
    icon: <PregnancyStageIcon size={16} />,
    bg: "#fdf4ff", border: "#e9d5ff",
  },
];

const dataCards = [
  { icon: <MenstrualIcon />,    label: "Menstrual Profile",     tag: "Regular",           tagPink: false, lines: ["29 ± 2 days", "Duration: 4–5 days"],                   cta: "View Details", ctaDanger: false },
  { icon: <IntentIcon />,       label: "Fertility Intent",      tag: "Actively Trying",   tagPink: true,  lines: ["Trying since: Jan 2025", "Goal: Pregnancy in 6 months"], cta: "Update",       ctaDanger: false },
  { icon: <ContraceptionIcon />,label: "Contraception History", tag: "None",              tagPink: false, lines: ["Previously: OCP (3 yrs ago)", "Current: Not using"],      cta: "View History", ctaDanger: false },
  { icon: <ObstetricIcon />,    label: "Obstetric History",     tag: "G0 P0",             tagPink: false, lines: ["No prior pregnancies", "No pregnancy loss"],             cta: "Add History",  ctaDanger: false },
  { icon: <ConcernIcon />,      label: "Active Concerns",       tag: "None Reported",     tagPink: false, lines: ["Feels well overall", ""],                               cta: "Add Concern",  ctaDanger: false },
  { icon: <PreventiveIcon />,   label: "Preventive Gaps",       tag: null,                tagPink: false, lines: ["TSH Screening", "Vitamin D Test", "Rubella Immunity"],   cta: "Address Now",  ctaDanger: true  },
];

const aiInsights = [
  { icon: <CycleIcon />,       color: "#a855f7", title: "Complete fertility readiness assessment", sub: "Evaluate key biomarkers and optimize factors for conception.",       cta: "Start Assessment" },
  { icon: <FertilityIcon />,   color: "#ec4899", title: "Order TSH and HbA1c screening",           sub: "Early detection helps improve fertility outcomes.",                   cta: "Order Tests" },
  { icon: <NutritionIcon />,   color: "#f59e0b", title: "Start preconception nutrition plan",       sub: "Personalized nutrition to support fertility & pregnancy health.",    cta: "View Plan" },
  { icon: <AppointmentIcon />, color: "#06b6d4", title: "Book gynecology consultation",             sub: "Discuss cycle tracker data and preconception plan.",                 cta: "Book An Appointment" },
];

const symptomBulletColors = ["#22c55e","#3b82f6","#f59e0b","#a855f7"];

// ─── Component ────────────────────────────────────────────────
export default function LifeStageDetails() {
  const [activeTab, setActiveTab] = useState("Overview");

  return (
    <div className={styles.wrapper}>

      {/* ── Top Nav ── */}
      <nav className={styles.topNav}>
        <div className={styles.searchBar}>
          <SearchIcon />
          <span>Search patient, records…</span>
          <span className={styles.searchKbd}>Ctrl K</span>
        </div>
        <div className={styles.navRight}>
          <div className={styles.navIconBtn}>
            <BellIcon />
            <span className={styles.notifBadge}>6</span>
          </div>
          <div className={styles.navIconBtn}><HelpIcon /></div>
          <div className={styles.doctorInfo}>
            <div className={styles.doctorAvatar}>AS</div>
            <div>
              <div className={styles.doctorName}>Dr. Ananya Sharma</div>
              <div className={styles.doctorRole}>Gynecologist</div>
            </div>
          </div>
        </div>
      </nav>

      <div className={styles.main}>

        {/* ── Page Header ── */}
        <div className={styles.pageHeader}>
          <div>
            <h1 className={styles.pageTitle}>Life Stage Details</h1>
            <p className={styles.pageSubtitle}>Dynamic classification, transition signals, and care focus tailored to the patient's current stage.</p>
          </div>
          <div className={styles.headerActions}>
            <button className={styles.btnOutline}><EditIcon /> Update Stage</button>
            <button className={styles.btnPrimary}><PlusIcon /> Add Note</button>
          </div>
        </div>

        {/* ── Patient Card ── */}
        <div className={styles.patientCard}>
          {/* Left: avatar + info */}
          <div className={styles.patientLeft}>
            <div className={styles.avatarWrap}>
              <div className={styles.patientAvatar}>
                <img src="https://i.pravatar.cc/72?img=47" alt="Priya" onError={e => e.target.style.display = "none"} />
              </div>
              <span className={styles.verifiedBadge}><VerifiedIcon /></span>
            </div>
            <div>
              <div className={styles.patientName}>
                <span className={styles.patientNameText}>Priya Mehta</span>
                <span className={styles.onlineDot}>●</span>
              </div>
              <div className={styles.patientAge}>34 Years · 12 Mar 1991 · Female</div>
              <div className={styles.patientContacts}>
                <span className={styles.contactItem}><PhoneIcon /> +91 98765 43210</span>
                <span className={styles.contactItem}><MailIcon /> priya.mehta@gmail.com</span>
                <span className={styles.contactItem}><MapPinIcon /> Mumbai, Maharashtra</span>
              </div>
            </div>
          </div>

          {/* Life Stage */}
          <div className={styles.lifeStageBox}>
            <div className={styles.lifeStageLabel}>Current Life Stage</div>
            <div className={styles.lifeStagePill}>
              <ReproductiveIcon size={14} />
              <span className={styles.lifeStagePillText}>Reproductive Age</span>
            </div>
            <div className={styles.activeJourneyLabel}>Active Journey</div>
            <div className={styles.activeJourneyValue}>Preconception /<br />Fertility Readiness</div>
          </div>

          {/* Record Summary */}
          <div className={styles.recordSummary}>
            <div className={styles.recordSummaryTitle}>Record Summary</div>
            <div className={styles.recordGrid}>
              <span className={styles.recordKey}>BMI</span>
              <span className={styles.recordVal}>25.9 <span className={styles.overweightTag}>(Overweight)</span></span>
              <span className={styles.recordKey}>Last Visit</span>
              <span className={styles.recordVal}>12 May 2025</span>
              <span className={styles.recordKey}>Care Team</span>
              <span className={styles.recordVal}>Dr. A. Sharma<br />& 1 more</span>
            </div>
            <button className={styles.btnSecondary}>View Full Profile</button>
          </div>
        </div>

        {/* ── Stage Summary Cards ── */}
        <div className={styles.stageSummaryGrid}>
          {stageSummaryCards.map((c, i) => (
            <div key={i} className={styles.stageSummaryCard} style={{ background: c.bg, border: `1px solid ${c.border}` }}>
              <div className={styles.stageSummaryCardHeader}>
                <span style={{ color: "#a855f7" }}>{c.icon}</span>
                <span className={styles.stageSummaryCardHeaderLabel}>{c.label}</span>
              </div>
              {c.value && <div className={styles.stageSummaryCardValue}>{c.value}</div>}
              {c.isProgress && (
                <>
                  <div className={styles.progressBar}><div className={styles.progressFill} /></div>
                  <div className={styles.progressLabel}>92%</div>
                </>
              )}
              {c.lines && c.lines.map((l, j) => <div key={j} className={styles.signalLine}>· {l}</div>)}
              {c.sub && <div className={styles.stageSub} style={{ color: c.subColor || "#6b7280", fontWeight: c.subColor ? 600 : 400 }}>{c.sub}</div>}
              {c.badge && <span className={styles.ongoingBadge}>{c.badge}</span>}
              {c.sub2 && <div className={styles.stageSub2}>{c.sub2}</div>}
            </div>
          ))}
        </div>

        {/* ── Life Stage Journey ── */}
        <div className={styles.journeyCard}>
          <div className={styles.sectionTitle}>Women's Life Stage Journey</div>
          <div className={styles.journeyTrack}>
            {lifeStages.map((stage, i) => {
              const isLast = i === lifeStages.length - 1;
              const iconClass =
                stage.state === "active" ? styles.journeyIconActive :
                stage.state === "past"   ? styles.journeyIconPast   :
                styles.journeyIconFuture;
              const labelClass =
                stage.state === "active" ? styles.journeyLabelActive :
                stage.state === "past"   ? styles.journeyLabelPast   :
                styles.journeyLabelFuture;
              return (
                <div key={i} className={isLast ? styles.journeyStageWrapLast : styles.journeyStageWrap}>
                  <div className={styles.journeyStageCol}>
                    <div className={`${styles.journeyIcon} ${iconClass}`}>{stage.icon}</div>
                    <div className={`${styles.journeyLabel} ${labelClass}`}>{stage.name}</div>
                    {stage.state === "active" && <div className={styles.journeyActiveBar} />}
                  </div>
                  {!isLast && (
                    <div className={`${styles.journeyConnector} ${stage.state === "past" ? styles.journeyConnectorPast : styles.journeyConnectorFuture}`} />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* ── Stage Definition + Right Column ── */}
        <div className={styles.stageDetailGrid}>

          {/* Left panel */}
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div style={{ flex: 1 }}>
                <div className={styles.cardTitle}>Stage Definition / Overview</div>
                <p className={styles.overviewText}>
                  Reproductive Age encompasses the years when women are physically capable of becoming pregnant. This phase focuses on reproductive health, cycle regularity, fertility optimization, and preparation for a healthy pregnancy.
                </p>

                <div className={styles.subTitle}>Key Physiological Characteristics</div>
                {["Regular ovulatory menstrual cycles","Peak fertility window (ideal conception years)","Hormonal balance with estrogen & progesterone cycling","Optimal time for family planning and preconception care"].map((item, i) => (
                  <div key={i} className={styles.bulletRow}>
                    <div className={`${styles.bullet} ${styles.bulletPurple}`} />
                    <span className={styles.bulletText}>{item}</span>
                  </div>
                ))}

                <div className={styles.subTitle}>Typical Care Priorities</div>
                {["Fertility awareness & preconception optimization","Cycle health, ovulation tracking & nutrition","Mental well-being & stress management","Immunizations & genetic risk assessment"].map((item, i) => (
                  <div key={i} className={styles.checkRow}>
                    <span className={styles.checkGreen}><CheckIcon /></span>
                    <span className={styles.bulletText}>{item}</span>
                  </div>
                ))}
              </div>
              <div style={{ marginLeft: 16, flexShrink: 0 }}><BookIcon /></div>
            </div>

            <div className={styles.subTitle}>Relevant History and Context</div>
            <div className={styles.historyGrid}>
              {[
                ["Menarche Age","13 years"],["Gonadh...","Yes"],
                ["Cycle Pattern","Regular (28–30 days)"],["Contraception","None (Actively trying)"],
                ["Cycle Length","29 ± 2 days"],["Gravida / Para","G0 P0"],
                ["Sexual Activity",""],
              ].map(([k, v], i) => (
                <div key={i} style={{ display: "flex", gap: 8 }}>
                  <span className={styles.historyKey}>{k}</span>
                  <span className={styles.historyVal}>{v}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right column */}
          <div className={styles.rightCol}>
            {/* Symptoms */}
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <div className={styles.cardTitle}>Stage-specific Symptoms & Indicators</div>
                <BarChartIcon />
              </div>
              {["Mild cyclic cramping","Breast tenderness (luteal phase)","Ovulation signs (cervical mucus, mild mid-cycle pain)","Energy & mood variations across cycle"].map((item, i) => (
                <div key={i} className={styles.bulletRow}>
                  <div className={styles.bullet} style={{ background: symptomBulletColors[i] }} />
                  <span className={styles.bulletText}>{item}</span>
                </div>
              ))}
            </div>

            {/* Risk Flags */}
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <div className={styles.cardTitle}>Risk Flags & Watchouts</div>
                <ShieldIcon />
              </div>
              {["Irregular cycles (>35 days or <21 days)","History of PCOS or insulin resistance","Thyroid dysfunction","Vitamin D deficiency","BMI outside healthy range"].map((item, i) => (
                <div key={i} className={styles.warningRow}>
                  <AlertTriangleIcon />
                  <span className={styles.bulletText}>{item}</span>
                </div>
              ))}
            </div>

            {/* Screenings */}
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <div className={styles.cardTitle}>Recommended Screenings & Assessments</div>
                <ClipboardIcon />
              </div>
              {["CBC, TSH, HbA1c","Vitamin D, B12, Ferritin","Thyroid profile","Rubella, Varicella immunity","Pelvic ultrasound (if indicated)"].map((item, i) => (
                <div key={i} className={styles.bulletRow}>
                  <div className={`${styles.bullet} ${styles.bulletIndigo}`} />
                  <span className={styles.bulletText}>{item}</span>
                </div>
              ))}
            </div>

            {/* AI Next Best Actions */}
            <div className={styles.cardAiInsight}>
              <div className={styles.cardHeader}>
                <div className={styles.cardTitle}>AI-Generated Next Best Actions</div>
                <SparkleIcon />
              </div>
              {["Complete fertility readiness assessment","Optimize nutrition, folic acid & lifestyle","Screen for thyroid & metabolic risks","Track ovulation & cycle regularity"].map((item, i) => (
                <div key={i} className={styles.bulletRow}>
                  <div className={`${styles.bullet} ${styles.bulletViolet}`} />
                  <span className={styles.bulletText}>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Stage-Specific Data Tabs ── */}
        <div className={styles.tabsCard}>
          <div className={styles.sectionTitle} style={{ marginBottom: 14 }}>Stage-Specific Data</div>
          <div className={styles.tabBar}>
            {TABS.map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`${styles.tabBtn} ${activeTab === tab ? styles.tabBtnActive : ""}`}
              >{tab}</button>
            ))}
          </div>
          <div className={styles.overviewDataGrid}>
            {dataCards.map((card, i) => (
              <div key={i} className={styles.dataCard}>
                <div className={styles.dataCardHeader}>
                  {card.icon}
                  <span className={styles.dataCardLabel}>{card.label}</span>
                </div>
                {card.tag && (
                  <div className={`${styles.dataCardTag} ${card.tagPink ? styles.dataCardTagPink : ""}`}>{card.tag}</div>
                )}
                {card.lines.map((l, j) => l && <div key={j} className={styles.dataCardLine}>{l}</div>)}
                <button className={`${styles.dataCardCta} ${card.ctaDanger ? styles.dataCardCtaRed : ""}`}>{card.cta}</button>
              </div>
            ))}
          </div>
        </div>

        {/* ── AI Life Stage Insights ── */}
        <div className={styles.aiInsightsCard}>
          <div className={styles.aiInsightsHeader}>
            <span className={styles.sectionTitle} style={{ marginBottom: 0 }}>AI Life Stage Insights</span>
            <SparkleIcon />
          </div>
          <div className={styles.aiInsightsGrid}>
            {aiInsights.map((item, i) => (
              <div key={i} className={styles.aiInsightItem}>
                <div className={styles.aiInsightItemHeader}>
                  <div className={styles.aiInsightIconWrap} style={{ background: `${item.color}15` }}>
                    {item.icon}
                  </div>
                  <span className={styles.aiInsightTitle}>{item.title}</span>
                </div>
                <p className={styles.aiInsightSub}>{item.sub}</p>
                <button
                  className={styles.aiInsightCta}
                  style={{ color: item.color, border: `1.5px solid ${item.color}20`, background: `${item.color}08` }}
                >
                  {item.cta} <ArrowRightIcon />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* ── Care Plan & Milestones ── */}
        <div className={styles.carePlanCard}>
          <div className={styles.sectionTitle}>Care Plan & Milestones</div>
          <div className={styles.carePlanGrid}>

            {/* Goals */}
            <div className={styles.carePlanItem}>
              <div className={styles.carePlanItemHeader}>
                <CheckCircleIcon color="#22c55e" />
                <span className={styles.carePlanItemTitle}>Goals</span>
              </div>
              {["Achieve healthy pregnancy in 6 months","Optimize cycle regularity","Build optimal nutrition & fitness"].map((g, i) => (
                <div key={i} className={styles.goalRow}>
                  <span className={styles.checkGreen}><CheckIcon /></span>
                  <span className={styles.goalText}>{g}</span>
                </div>
              ))}
              <button className={styles.btnSecondary}>View Goals</button>
            </div>

            {/* Active Programs */}
            <div className={styles.carePlanItem}>
              <div className={styles.carePlanItemHeader}>
                <HeartIcon />
                <span className={styles.carePlanItemTitle}>Active Programs</span>
              </div>
              {[["Preconception Care Program","#22c55e"],["Nutrition & Lifestyle Coaching","#3b82f6"]].map(([prog, color], i) => (
                <div key={i} className={styles.programRow}>
                  <span className={styles.programName}>{prog}</span>
                  <span className={styles.programBadge} style={{ background: `${color}15`, color }}>In Progress</span>
                </div>
              ))}
              <button className={styles.btnSecondary}>View Programs</button>
            </div>

            {/* Upcoming Tasks */}
            <div className={styles.carePlanItem}>
              <div className={styles.carePlanItemHeader}>
                <ClipboardIcon />
                <span className={styles.carePlanItemTitle}>Upcoming Tasks</span>
              </div>
              {[
                ["Complete TSH Test","Due on 18 May 2025","#ef4444"],
                ["Ovulation Tracking Review","Due on 22 May 2025","#f59e0b"],
                ["Follow-up Consultation","Due on 01 Jun 2025","#6b7280"],
              ].map(([task, due, color], i) => (
                <div key={i} className={styles.taskRow}>
                  <div className={styles.taskName}>{task}</div>
                  <div className={styles.taskDue} style={{ color }}>{due}</div>
                </div>
              ))}
              <button className={styles.btnSecondary}>View All Tasks</button>
            </div>

            {/* Next Follow-up */}
            <div className={styles.carePlanItem}>
              <div className={styles.carePlanItemHeader}>
                <CalendarIcon />
                <span className={styles.carePlanItemTitle}>Next Follow-up</span>
                <span className={styles.followUpMeta}>01 Jun 2025, 10:30 AM</span>
              </div>
              <div className={styles.followUpDoc}>
                <div className={styles.followUpDocAvatar}>AS</div>
                <div>
                  <div className={styles.followUpDocName}>Dr. Ananya Sharma</div>
                  <div className={styles.followUpDocRole}>Gynecologist</div>
                  <div className={styles.followUpDocClinic}>Avexa Women's Health Clinic, Mumbai</div>
                </div>
              </div>
              <button className={styles.btnDanger}>Reschedule</button>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}